import React, { useContext } from 'react';
import css from 'styled-jsx/css';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { colors } from '../Theme';

import MatomoAsyncProvider from '../../common/services/MatomoProvider';

import { SUPPORT_FORM_TOGGLE_ID } from './SupportForm';
import SupportIcon from '../../../../public/static/images/icons/support.svg';

const buttonFixedStyles = css`
  .button-fixed {
    position: fixed;
    display: flex;
    padding: 10px;
    bottom: 15px;
    right: 2vw;
    background-color: ${colors.ywgPinkishOrange};
    border-radius: 50%;
    cursor: pointer;
    z-index: 20;
  }
`;

const SupportFormToggle = ({ className, buttonText }) => {
  const tracking = useContext(MatomoAsyncProvider.Context);
  const labelClicked = () => {
    tracking.trackEvent('Support', 'Click', 'Floating label');
  };

  return (
    <>
      <label
        htmlFor={SUPPORT_FORM_TOGGLE_ID}
        className={classnames(className, {
          'button-fixed': !buttonText
        })}
        onClick={labelClicked}
      >
        {buttonText ? (
          buttonText
        ) : (
          <>
            <SupportIcon
              width="36"
              height="36"
              fill="white"
              aria-hidden="true"
            />
            <span className="sr-only">Afficher le formulaire de support</span>
          </>
        )}
      </label>
      <style jsx>{buttonFixedStyles}</style>
    </>
  );
};

SupportFormToggle.propTypes = {
  className: PropTypes.string,
  buttonText: PropTypes.string
};

export default SupportFormToggle;
